import type { FC } from 'react';
import { DesktopMenu } from './desktop-menu.component';
import { MobileMenu } from './mobile-menu.component';
import { useTheme } from 'styled-components';
import { useMediaQuery } from '../../hooks/media-query.hook';

export const Menu: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.media.tablet.replace('@media ', ''));

  return isMobile ? <MobileMenu /> : <DesktopMenu />;
};
